'use strict';

const prefix = 'leaderboard_filters';
const config = {
    selectors: {
        form: 'form[name=' + prefix +']',
        query: '#' + prefix + '_query',
        jobRole: '#' + prefix + '_jobRole',
        countryOfResidence: '#' + prefix + '_countryOfResidence'
    }
};

$(document).ready(function() {
    let $form = $(config.selectors.form);
    if ($form.length < 1) {
        return;
    }

    $form.on('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.search = '?'.concat($.param({
            page: 1,
            query: $(config.selectors.query).val() || null,
            jobRole: $(config.selectors.jobRole).val() || null,
            countryOfResidence: $(config.selectors.countryOfResidence).val() || null
        }));
    });

    $(config.selectors.query).on('blur', function () {
        let value = $(this).val() || '';
        if (value.trim().length < 1) {
            return;
        }
        $form.submit();
    });

    let formFields = ['jobRole', 'countryOfResidence'];
    formFields.forEach(function (field) {
        let $node = $(config.selectors[field]);
        $node && $node.on('change', function () {
            $form.submit();
        });
    });
});



// WEBPACK FOOTER //
// ./src/js/components/leaderboard.js